import axios from 'axios'
import { trackPromise } from 'react-promise-tracker';
import * as CommonVariables from '../../Common/CommonVariables'

export const GetOrganizationListByAccountCode = async (accountCode) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Account/GetOrganizationListByAccountCode?accountCode=${accountCode}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetPartnerBalance = async () => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Account/GetPartnerBalance`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const PatientVisitExcelDownload = async (data) => {
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `Account/PatientVisitExcelDownload`, JSON.stringify(data), CommonVariables.API_HEADER)).then(response => response);
    return result;
}

export const GetUniversalPatientVistDetailForSales = async (searchText) => {
    var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `Account/GetUniversalPatientVistDetailForSales?searchText=${searchText}`, CommonVariables.API_HEADER)).then(response => response);
    return result;
}


export const GetRevenueShareReport = async (requestData) => {
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `Account/GetRevenueShareReport`, JSON.stringify(requestData), CommonVariables.API_HEADER)).then(response => response);
    return result;
}